"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;

var React = __importStar(require("react"));

var core_1 = require("@emotion/core");

var utils_1 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation"); // @ts-ignore


exports.ProgressBar = utils_1.forwardRef(function ProgressBar(props, ref) {
  var value = props.value,
      type = props.type,
      rest = __rest(props, ["value", "type"]);

  var _a = React.useState(0),
      computedValue = _a[0],
      setComputedValue = _a[1];

  React.useEffect(function () {
    return setComputedValue(value > 0 && value <= 100 ? value : value > 100 ? 100 : 0);
  }, [value]);

  var renderBackground = function renderBackground() {
    var type = props.type;

    switch (type) {
      case 'success':
        return {
          background: foundation_1.colors.status.success10,
          foreGround: foundation_1.colors.status.success
        };

      case 'canceled':
        return {
          background: foundation_1.colors.secondary.mediumGrey,
          foreGround: foundation_1.colors.secondary.mediumGrey
        };

      case 'warning':
        return {
          background: foundation_1.colors.status.warning10,
          foreGround: foundation_1.colors.status.warning
        };

      case 'error':
        return {
          background: foundation_1.colors.status.error10,
          foreGround: foundation_1.colors.status.error
        };

      default:
        return {
          background: foundation_1.colors.status.success10,
          foreGround: foundation_1.colors.status.success
        };
    }
  };

  var progressBarContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tborder-radius: 10px;\n\t\theight: 0.5em;\n\t\tbackground: ", ";\n\t\ttransition: all 0.2s ease-in-out;\n\t"], ["\n\t\twidth: 100%;\n\t\tborder-radius: 10px;\n\t\theight: 0.5em;\n\t\tbackground: ", ";\n\t\ttransition: all 0.2s ease-in-out;\n\t"])), renderBackground().background);
  var progressBar = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\twidth: 0;\n\t\tborder-radius: 10px;\n\t\theight: 0.5em;\n\t\tbackground: ", ";\n\t\ttransition: width 0.2s ease-in-out;\n\t"], ["\n\t\twidth: 0;\n\t\tborder-radius: 10px;\n\t\theight: 0.5em;\n\t\tbackground: ", ";\n\t\ttransition: width 0.2s ease-in-out;\n\t"])), renderBackground().foreGround);
  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: progressBarContainer
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: progressBar,
    style: {
      width: computedValue + "%"
    }
  }));
});
var templateObject_1, templateObject_2;